// extracted by mini-css-extract-plugin
export default {"wrapper":"backToTopButton_wrapper__MUueb","icon":"backToTopButton_icon__VQdZh","fadebottom":"backToTopButton_fadebottom__s17lg"};